import React, { Component } from "react";
import IconRoute from "./IconRoute";
import BuyButton from "./BuyButton";
import Price from "./Price";

const LeftSide = ({ leaveTime, arriveTime, leaveCity, arriveCity, duration }) => (
	<div className="flight-row">
		<div className="row">
			<div className="col-xs-16 col-md-8 bus-route">
				<i className="icon-bus" />
				<IconRoute />
				<div>
					<p className="bus-city">
						<span className="bus-time">{leaveTime}</span>
						{leaveCity}
					</p>
					<p className="bus-city no-margin">
						<span className="bus-time">{arriveTime}</span>
						{arriveCity}
					</p>
				</div>
			</div>
			<div className="col-xs-8 col-md-4 no-padding">
				<div className="duration">
					<span className="flight-duration">{duration}</span>
					<span className="flight-stops" aria-label="Paradas do voo">
						duração
					</span>
				</div>
			</div>
			<div className="col-xs-8 col-md-4 bus-class">
				<div className="flight-timming">
					<span className="flight-destination">Convencional</span>
				</div>
				<span className="flight-data">classe</span>
			</div>
		</div>
	</div>
);

const Luggage = () => (
	<div className="dispatch-luggage not-included">
		<span>
			<i className="icon icon-bad-on-board"></i>Apenas bagagem de mão incluída
		</span>
	</div>
);

class BusCardV1 extends Component {
	render() {
		const { route, ...rest } = this.props;
		return (
			<div className="flight-item bus-item">
				<div className="container-fluid">
					<div className="row flex-row">
						<div className="col-xs-16 col-md-12 v-center-columns flight-item-information">
							{route ? (
								<>
									<LeftSide
										leaveTime={route.horarioSaida}
										arriveTime={route.horarioChegada}
										leaveCity={route.origem}
										arriveCity={route.destino}
										duration={route.duracao}
									/>
									<Luggage />
								</>
							) : (
								<div className="lazyload" />
							)}
						</div>
						<div className="col-xs-16 col-md-4 v-center-columns flight-item-price">
							<div className="highlight-price">
								{route ? (
									<>
										<Price price={route.preco} />
										<BuyButton {...rest} />
									</>
								) : (
									<div className="lazyload" />
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default BusCardV1;
